<template>
  <div>
    <h1>Log</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
